// SPEC D-1009 (坂本 浩一 2026-10-07 app_feedback 4da58047「戻る、の < が小さすぎて押しにくいから大きくして欲しい」):
//   戻るボタンの当たり判定を 1 か所で決める。48×48 の箱。
// D-1010 (ひろ 2026-10-08): 字(← / ‹ / ⌂)をやめて線のアイコン(shared/ui/icons/NavIcons.jsx)にした。
//   ★中身は <BackIcon /> / <HomeIcon />(26px)。箱の class はここ、アイコンの大きさは NAV_ICON_PX。
//   ★ホーム(⌂)も戻ると同じ class を使う(同じ箱・同じ見た目)。
//   ★テストは字ではなく data-testid で掴む(D-630)。

/** 箱の一辺(px)。タップ領域の下限 44px(.claude/rules/ui.md)に余裕を持たせて 48。 */
export const BACK_BUTTON_PX = 48

/** 箱。w-12 h-12 = 48×48。 */
export const BACK_BUTTON_BOX = 'shrink-0 w-12 h-12 flex items-center justify-center leading-none active:opacity-70'

/**
 * 戻る/ホームボタンの className。
 * @param {string} tone 色など画面固有の class(既定 text-muted)。アイコンは currentColor なのでこの色で描かれる。
 */
export function backButtonClass(tone = 'text-muted') {
  return `${BACK_BUTTON_BOX} ${tone}`.trim()
}

/**
 * ヘッダの行の高さが固定されている所(PageHeader compact = 80px を e2e が固定 / D-660)向け。
 *   ★箱は 48×48 にしつつ、-m-0.5 で外形(レイアウト上の占有)を従来の 44×44 に保つ。
 *     ヘッダの高さもタイトルの幅も 1px も変わらない。はみ出す 2px は隣との gap(8px)の中に収まる。
 */
export function headerBackButtonClass(tone = 'text-muted') {
  return `${backButtonClass(tone)} -m-0.5`
}

/**
 * 1 行の細いヘッダ(py-2.5 / py-3 で、今まで字の高さ 20〜24px で行が決まっていた所)向け。
 *   ★箱は 48×48 のまま、-my-2 で縦の占有を 32px にする。はみ出す上下 8px はヘッダ自身の
 *     上下 padding(10〜12px)の中に収まるので、ヘッダが 24px も伸びて一覧が押し下がることはない。
 */
export function compactHeaderBackButtonClass(tone = 'text-muted') {
  return `${backButtonClass(tone)} -my-2`
}
